import React from 'react';

import Tooltip from './Tooltip';

import './NumberLine.module.css';

const NumberLine = ({ maxTitle, minTitle, name, tooltip, value }) => (
  <div styleName="wrapper">
    <div styleName="name">
      <h2>{name}</h2>
      {tooltip ? <Tooltip type="information">{tooltip}</Tooltip> : null}
    </div>
    <div styleName="content">
      <span>{minTitle}</span>
      <div styleName="graph">
        <span styleName="value" style={{ width: `${value}%` }}>
          {value}
        </span>
      </div>
      <span>{maxTitle}</span>
    </div>
  </div>
);

export default NumberLine;
